import { getAxiosClient } from "../../axios-client";
import {
  PricelistOffersGetByIdBody,
  PricelistOffersGetByIdResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const getOrdersPricelistOffersById = async (
  body: PricelistOffersGetByIdBody
) => {
  return await axiosClient.ax.post<PricelistOffersGetByIdResponse>(
    "/Orders/PricelistOffersGetById",
    body
  );
};
